import React from 'react'

import PasswordChanger from './PasswordChanger';

const User = (props) => {

    const handlePwChange = (password) => {
        props.changePassword(props.username, password);
    };

    return (
        <tr>
            <td>{props.username}</td>
            <td>{props.roles}</td>
            <td><PasswordChanger onCommit={handlePwChange}/></td>
        </tr>
    );
};

export default User;



// WEBPACK FOOTER //
// ./src/admin/user/User.js